










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class EvoTalksSyncingDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;
}
